import { render, staticRenderFns } from "./Textbox.vue?vue&type=template&id=16b3fd21&scoped=true"
import script from "./Textbox.vue?vue&type=script&lang=js"
export * from "./Textbox.vue?vue&type=script&lang=js"
import style0 from "./Textbox.vue?vue&type=style&index=0&id=16b3fd21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b3fd21",
  null
  
)

export default component.exports